import React from 'react';
import styled from 'styled-components';
// import issue1 from '../../images/issue_1.png';
// import issue2 from '../../images/issue_2-1.png';
import issue1 from '../../images/pointer.svg';
import issue2 from '../../images/happy_face.svg';
import { trackCustomEvent } from "gatsby-plugin-google-analytics";
import icon_1 from '../../images/sidebar_icon_1.svg';
import icon_2 from '../../images/sidebar_icon_2.svg';
import icon_3 from '../../images/sidebar_icon_3.svg';
import icon_4 from '../../images/sidebar_icon_4.svg';
import icon_5 from '../../images/sidebar_icon_5.svg';

const Banner = styled.div`
	position: relative;
	z-index: 1;
	background-color: white;
	border-radius: 8px;
	box-shadow: 0 30px 60px 0 rgba(50, 75, 93, 0.1), 0 18px 36px 0 rgba(63, 52, 146, 0.05);
	padding: 33px 30px 23px;
`;
const BannerTitle = styled.h2`
	font-size: 20px;
	margin: 0 0 27px 0;
	letter-spacing: -0.002em;
	color: #2a3476;
`;
const BannerList = styled.div`
	margin-bottom: 30px;
`;
const BannerListItem = styled.div`
	display: flex;
	margin-bottom: 20px;
`;
const BannerListItemIcon = styled.div`
	background-image: url('${(props) => props.src}');
	flex: 0 0 53px;
	margin-right: 18px;
	width: 53px;
	height: 53px;
	border-radius: 50%;
	overflow: hidden;
	box-shadow: 0 6px 8px rgba(63, 52, 146, 0.09);
	display: flex;
	padding: 10px;
	background-position: center;
	background-repeat: no-repeat;
`;
const BannerListItemContent = styled.div`
	padding-top: 13px;
`;
const BannerListItemContentTitle = styled.h3`
	padding: 0;
	margin: 0 0 10px 0;
	font-weight: 700;
	font-size: 14px;
	color: #2a3476;
`;
const BannerListItemContentDescription = styled.p`
	padding: 0;
	margin: 0;
	font-weight: 500;
	// color: #a5b3c3;
	color: #99aabbef;
	font-size: 13px;
	line-height: 1.3em;
`;
const Button = styled.button`
	border-radius: 8px;
	background-color: #e01efe;
	color: #fffffff6;
	width: 100%;
	text-align: center;
	padding: 14px 40px;
	font-weight: 600 !important;
	transition: all 0.3s ease-in-out 0s;
	border: 1px solid #e01efe;

	:hover {
		color: #e01efe;
		background-color: #fff;
	}
`;

export default function SolveIssueBanner({ url }) {
	return (
		<Banner>
			<BannerTitle>Things you can do with DoNotPay</BannerTitle>
			<BannerList>
				<BannerListItem>
					<BannerListItemIcon src={icon_1} />
					<BannerListItemContent>
						<BannerListItemContentTitle>Fight Corporations</BannerListItemContentTitle>
						{/* <BannerListItemContentDescription>Let DoNotPay solve this problem for me.</BannerListItemContentDescription> */}
					</BannerListItemContent>
				</BannerListItem>
				<BannerListItem>
					<BannerListItemIcon src={icon_2} />
					<BannerListItemContent>
						<BannerListItemContentTitle>Beat Bureacracy</BannerListItemContentTitle>
					</BannerListItemContent>
				</BannerListItem>
                <BannerListItem>
					<BannerListItemIcon src={icon_3} />
					<BannerListItemContent>
						<BannerListItemContentTitle>Find Hidden Money</BannerListItemContentTitle>
					</BannerListItemContent>
				</BannerListItem>
                <BannerListItem>
					<BannerListItemIcon src={icon_4} />
					<BannerListItemContent>
						<BannerListItemContentTitle>Cancel Subscriptions</BannerListItemContentTitle>
					</BannerListItemContent>
				</BannerListItem>
                <BannerListItem>
					<BannerListItemIcon src={icon_5} />
					<BannerListItemContent>
						<BannerListItemContentTitle>Cancel Your Free Trial</BannerListItemContentTitle>
					</BannerListItemContent>
				</BannerListItem>
			</BannerList>
			{/* <Link to={url}> */}
			<Button
				onClick={() => {
					trackCustomEvent({
						category: "Learning Center CTA Click",
						action: "click",
						label: "Get Started, Sidebar",
					});
					trackCustomEvent({
						category: "Entire page tracker",
						action: "click",
						label: "Get Started, Sidebar",
					});
					document.location = url
				}}
				className="smp-side"
			>
				Sign up for DoNotPay
			</Button>
			{/* 	</Link> */}
		</Banner>
	);
}
